import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-aurora-text',
  imports: [],
  templateUrl: './aurora-text.component.html',
  styleUrl: './aurora-text.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuroraTextComponent {
  @Input() componentClass = '';
}
